import React from "react";
import { Divider, Flex, Typography } from "antd";
import { observer } from "mobx-react-lite";
import { FileInput, UploadedFileDisplay } from "ui";
import { DocUploadedResponse, FILE_TYPE_ENUM } from "interfaces";
import { SEND_STEP } from "./SendBidModal";

interface FileUploadSectionProps {
  loading: boolean;
  uploadedFiles: DocUploadedResponse[];
  setUploadedFiles: (files: DocUploadedResponse[]) => void;
  sendStep: string;
  setSendStep: (step: any) => void;
}

export const FileUploadSection = observer((props: FileUploadSectionProps) => {
  const { loading, uploadedFiles, setUploadedFiles, sendStep, setSendStep } = props;

  const handleUploadFile = async (responseUpload: DocUploadedResponse[]) => {
    const newFiles = [...uploadedFiles, ...responseUpload];
    setUploadedFiles(newFiles);
    return Promise.resolve();
  };

  const handleRemoveInvoice = (file: DocUploadedResponse) => {
    const filteredFiles = uploadedFiles.filter((item) => item.id !== file.id);
    setUploadedFiles(filteredFiles);

    if (uploadedFiles.length < 1) {
      setSendStep(SEND_STEP.SEND);
    }
  };

  return (
    <Flex vertical className="margin-top-lg" id="create-bid-invoice-input">
      <Typography.Title level={2}>Скан инвойса</Typography.Title>
      <Flex vertical gap="small">
        {uploadedFiles.length > 0 && (
          <Flex vertical gap="small">
            {uploadedFiles.map((item) => (
              <Flex vertical key={item.id}>
                <Flex justify="center" vertical className="uploadedFileBlock">
                  <UploadedFileDisplay
                    fileName={item.originalFilename}
                    onRemove={() => handleRemoveInvoice(item)}
                    tooltip="Удалить документ"
                    showRemoveIcon={!loading}
                  />
                </Flex>
              </Flex>
            ))}
          </Flex>
        )}
        {!loading && (
          <FileInput
            fileType={FILE_TYPE_ENUM.INVOICE}
            onUpload={handleUploadFile}
            multiple
            isContinue={uploadedFiles.length > 0}
            smallSize={uploadedFiles.length > 0}
          />
        )}
      </Flex>
    </Flex>
  );
});
